<template>
  <div class="footer">
    <div class="container">
      <div class="content">
        <div class="menu-footer">
          <div class="menu">
            <router-link style="text-decoration: none" to="/about">
              <span class="menu--item"> About Us </span>
            </router-link>

            <router-link style="text-decoration: none" to="/privacy">
              <span class="menu--item"> Privacy </span>
            </router-link>
            <router-link style="text-decoration: none" to="/termsServices">
              <span class="menu--item"> Terms of Service </span>
            </router-link>
          </div>

          <div class="download">
            <p>
              Download <strong>OTT WATCHLIST</strong> App
              <span
                >Get <strong>Free</strong> Access To The Streaming Guide With No
                Ad Interruptions. Find Your Next Binge Watch.</span
              >
            </p>
          </div>

          <div class="store">
            <a target="_blank" rel="noreferrer" :href="`${info.iosStoreUrl}`">
              <img
                class="store--image"
                alt="appstore"
                src="../../../assets/movie/istore.png"
            /></a>
            <a
              target="_blank"
              rel="noreferrer"
              :href="`${info.androidStoreUrl}`"
            >
              <img
                class="store--image"
                alt="google play"
                src="../../../assets/movie/gplay.png"
              />
            </a>
          </div>
        </div>

        <div class="form-contact"><ith-form-contact /></div>
        <div class="form-feedback"><ith-form-feedback /></div>
      </div>

      <div class="copyrigth">
        <span>© 2021 OTT WATCHLIST. All rights reserved.</span>
        <div class="rrss">
          <div class="rrss--icon">
            <a
              target="_blank"
              rel="noreferrer"
              :href="`https://twitter.com/${info.twitterUsername}`"
              ><font-awesome-icon :icon="['fab', 'twitter']"
            /></a>
            <a
              target="_blank"
              rel="noreferrer"
              :href="`https://www.facebook.com/${info.facebookUsername}`"
              ><font-awesome-icon :icon="['fab', 'facebook-f']"
            /></a>
            <a
              target="_blank"
              rel="noreferrer"
              :href="`https://www.instagram.com/${info.instagramUsername}`"
              ><font-awesome-icon :icon="['fab', 'instagram']"
            /></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    info: {
      instagramUsername: "",
      facebookUsername: "",
      androidStoreUrl: "",
      iosStoreUrl: "",
      twitterUsername: ""
    }
  }),
  created() {
    this.$Parse.Cloud.run("getAppInfo", this.params)
      .then(res => {
        this.info = res;
      })
      .catch(error => {
        console.log(error);
      });
  }
};
</script>

<style scoped>
.footer {
  margin-top: 100px;
  background-color: rgba(0, 0, 0, 0.2);
  text-align: center;
  font-size: 0.9rem;
  color: #d5d5d5;
}

.download,
.content {
  padding: 20px 0px 0px 0px;
}

.download {
  width: 100%;
  font-size: 0.9em;
  padding-bottom: 10px;
}
.content {
  display: grid;
  grid-template-columns: 40% repeat(2, 28%);
  column-gap: 2%;
  padding-bottom: 2%;
  border-bottom: 1px solid #738092;
}

.menu-footer {
  padding-left: 15px;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 50% 25% 25%;
}

.form-contact {
  justify-self: stretch;
  padding: 0;
}
.form-feedback {
  justify-self: stretch;
  padding: 0;
}
.menu {
  align-self: start;
  display: grid;
  grid-template-columns: 100%;
  align-items: end;
  justify-items: start;
  row-gap: 20px;
}
.menu--item {
  color: white;
}

.router-link-active {
  font-weight: 600;
}

.download {
  text-align: left;
  align-self: end;
}

.store {
  align-self: end;
  display: grid;
  grid-template-columns: repeat(2, auto);
  justify-content: start;
  column-gap: 15px;
  cursor: pointer;
}

.store--image {
  border-radius: 10px;
  width: 170px;
  height: 65px;
  object-fit: cover;
}
.rrss--icon {
  display: grid;
  grid-template-columns: repeat(3, auto);
  justify-content: end;
  column-gap: 20px;
}
.rrss--icon > a {
  font-size: 1.7em;
  color: #939292;
}

.copyrigth {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  height: 55px;
  color: #d5d5d5;
  font-size: 0.75rem;
  padding: 20px 15px 0px 15px;
}
.copyrigth > span {
  justify-self: start;
}

@media (min-width: 1264px) and (max-width: 1400px) {
}
@media (min-width: 1020px) and (max-width: 1264px) {
}
@media (min-width: 960px) and (max-width: 1020px) {
}
@media (min-width: 960px) and (max-width: 1264px) {
}
@media (min-width: 600px) and (max-width: 960px) {
  .content {
    grid-template-columns: 100%;
    row-gap: 30px;
  }
}
@media (max-width: 600px) {
  .store--image {
    border-radius: 10px;
    width: 130px;
    height: 50px;
    object-fit: cover;
  }
  .content {
    grid-template-columns: 100%;
    row-gap: 30px;
  }
}
</style>
